import React from 'react';
import { Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import MessageInfoSection from '../MessageInfoSection/MessageInfoSection';
import { getMessageDetailsThemeColors } from '../MessageDetails.helpers';

const { Text } = Typography;

const MessageTransactionInfo = ({ transactionInfo, isDarkMode }) => {
    const { t } = useTranslation();
    const themeColors = getMessageDetailsThemeColors(isDarkMode);

    if (!transactionInfo) return null;

    return (
        <MessageInfoSection title={t('transaction_information')}>
            <Space direction="vertical">
                <Text style={{ color: themeColors.text }}>{t('coins_amount')}: {transactionInfo.coins_amount}</Text>
                <Text style={{ color: themeColors.text }}>{t('transaction_id')}: {transactionInfo.transaction_id}</Text>
            </Space>
        </MessageInfoSection>
    );
};

export default MessageTransactionInfo;
